// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"styles_paragraph__3nkgT","title":"styles_title__1sm7v","subTitle":"styles_subTitle__31Gmq","imgWrapper":"styles_imgWrapper__RMSvu","zoom":"styles_zoom__34Bp4"};